import React, { useEffect, useMemo, useState } from 'react';
import { UIRouter } from '@uirouter/core';

import { RouterContext } from '../context';
import { clientPlugin } from '../../plugins/client';
import type { IRouterProps } from '../../plugins/controller';

interface IProps extends IRouterProps {
  children: React.ReactNode;
}

export function Router(props: IProps) {
  const { children, $$router$$, $$router_methods$$ } = props;

  const router = useMemo(() => {
    const router = new UIRouter();

    router.plugin(clientPlugin($$router$$.location));

    for (const state in $$router$$.states) {
      router.stateRegistry.register($$router$$.states[state]);
    }

    return router;
  }, []);

  const [state, setState] = useState({
    router,
    ...$$router$$,
    ...$$router_methods$$,
  });

  useEffect(() => {
    setState((state) => ({
      ...state,
      current: $$router$$.current,
    }));
  }, [JSON.stringify($$router$$.current)]);

  useEffect(() => {
    return () => router.dispose();
  }, []);

  return (
    <RouterContext.Provider value={state}>{children}</RouterContext.Provider>
  );
}

Router.displayName = 'Router';
